var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 188,
    viewBox: "0 0 200 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_7)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.8941 30.5334C49.8941 30.5334 79.9179 52.2655 125.562 11.6304C166.098 -24.4565 199.196 32.4806 199.428 59.7468C199.728 95.0671 158.892 123.329 178.71 146.528C198.527 169.727 139.408 208.036 107.546 174.882C67.9101 133.639 57.1724 167.149 34.5803 167.149C18.3657 167.149 -14.9245 128.72 7.55598 100.13C26.4731 76.0719 16.156 68.0875 11.1599 59.7468C3.9528 47.7178 21.0682 15.0675 49.8941 30.5334Z",
    fill: "#D6DAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 40.25C140 41.3851 140.861 41.9811 141.865 41.9811C144.648 41.9811 143.213 38.2351 146.885 38.2351C148.607 38.2351 149.639 39.1432 149.639 40.6757C149.639 43.4568 144.619 44.223 144.619 47.6C144.619 48.5081 145.221 49.5014 146.455 49.5014C148.348 49.5014 148.119 48.1108 148.807 47.1176C149.725 45.7838 154 44.3649 154 40.6757C154 36.6743 150.385 35 146.713 35C143.213 35 140 37.4689 140 40.25ZM144.217 53.673C144.217 54.95 145.279 56 146.57 56C147.861 56 148.922 54.95 148.922 53.673C148.922 52.3959 147.861 51.3459 146.57 51.3459C145.279 51.3459 144.217 52.3959 144.217 53.673Z",
    fill: "#515C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 72.5C32 73.473 32.7377 73.9838 33.5984 73.9838C35.9836 73.9838 34.7541 70.773 37.9016 70.773C39.377 70.773 40.2623 71.5514 40.2623 72.8649C40.2623 75.2486 35.959 75.9054 35.959 78.8C35.959 79.5784 36.4754 80.4297 37.5328 80.4297C39.1557 80.4297 38.959 79.2378 39.5492 78.3865C40.3361 77.2432 44 76.027 44 72.8649C44 69.4351 40.9016 68 37.7541 68C34.7541 68 32 70.1162 32 72.5ZM35.6148 84.0054C35.6148 85.1 36.5246 86 37.6311 86C38.7377 86 39.6475 85.1 39.6475 84.0054C39.6475 82.9108 38.7377 82.0108 37.6311 82.0108C36.5246 82.0108 35.6148 82.9108 35.6148 84.0054Z",
    fill: "#515C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 115.25C143 117.034 144.352 117.97 145.93 117.97C150.303 117.97 148.049 112.084 153.82 112.084C156.525 112.084 158.148 113.511 158.148 115.919C158.148 120.289 150.258 121.493 150.258 126.8C150.258 128.227 151.205 129.788 153.143 129.788C156.119 129.788 155.758 127.603 156.84 126.042C158.283 123.946 165 121.716 165 115.919C165 109.631 159.32 107 153.549 107C148.049 107 143 110.88 143 115.25ZM149.627 136.343C149.627 138.35 151.295 140 153.324 140C155.352 140 157.02 138.35 157.02 136.343C157.02 134.336 155.352 132.686 153.324 132.686C151.295 132.686 149.627 134.336 149.627 136.343Z",
    fill: "#515C6F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.576,
    cy: 91.576,
    r: 41,
    transform: "rotate(-39.2057 94.576 91.576)",
    fill: "#C4C4C4",
    stroke: "#515C6F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.5762,
    cy: 91.576,
    r: 34.5,
    transform: "rotate(-39.2057 94.5762 91.576)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.168 125.242L122.817 121.45L156.319 162.519C157.366 163.802 157.175 165.692 155.891 166.74C154.607 167.787 152.717 167.595 151.67 166.311L118.168 125.242Z",
    fill: "#C4C4C4",
    stroke: "#515C6F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 103C87.5 97.6667 103 97.6667 108 103",
    stroke: "#515C6F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5743,
    cy: 88.5742,
    r: 2.57426,
    fill: "#515C6F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.574,
    cy: 88.5742,
    r: 2.57426,
    fill: "#515C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 82H100",
    stroke: "#515C6F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 81.8156C87 77.8156 81 78.3156 79 81.8156",
    stroke: "#515C6F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.43,
    height: 187.824,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.b72048bf932e2fe7d41853204174401b.svg";
export { ForwardRef as ReactComponent };